import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { parentSupervisionActions } from '../../../../../store';

function useEditSupervision(supervisionId: number | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [showConfirmEditDialog, setShowConfirmEditDialog] = useState(false);

  const handleEditSupervision = useCallback(async () => {
    if (!supervisionId) return;
    setShowConfirmEditDialog(false);

    const { error } = await dispatch(
      parentSupervisionActions.editParentSupervision({
        supervisionId: supervisionId,
        getAccessTokenSilently: getAccessTokenSilently,
      }),
    );

    if (!error) {
      location.reload();
    }
  }, [dispatch, getAccessTokenSilently, supervisionId]);

  return {
    showConfirmEditDialog,
    setShowConfirmEditDialog,
    handleEditSupervision,
  };
}

export default useEditSupervision;
